import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f207eee4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "production-billed-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, /*#__PURE__*/_toDisplayString('Comparativo Entrada Produção x Faturado'), -1))
const _hoisted_3 = {
  key: 1,
  class: "chart-group-legends"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"chart-legends\" data-v-f207eee4><span class=\"chart-legends-entradaprd\" data-v-f207eee4></span><p class=\"chart-legends-text\" data-v-f207eee4>Entrada Produção</p><span class=\"chart-legends-faturado\" data-v-f207eee4></span><p class=\"chart-legends-text\" data-v-f207eee4>Faturado</p></div>", 1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Overlay = _resolveComponent("Overlay")!
  const _component_VChart = _resolveComponent("VChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Overlay, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_VChart, {
          key: 2,
          id: "billed-chart",
          class: "chart",
          option: _ctx.options,
          autoresize: ""
        }, null, 8, ["option"]))
      : _createCommentVNode("", true)
  ]))
}